<template>
  <div class="core-bottom-content">
    <div class="top">
      <div class="top-title">
        <div class="tab-item" v-for="(data,index) in itemList" :key="index" @click="changeBg(index,data)" :class="{'top-crib-title-num-active': data.sign === 1}">
          {{data.title}}
        </div>
      </div>
      <div class="top-select">
        <DropDown STYLE="margin-right: 1vw" :content="sort" :items="sortList" @sendInfo = "showInfoA" v-if="value!==1"></DropDown>
        <DropDownNext changeTitle="false" :content="title" :items="selectList" v-on:sendInfo = "showInfo"></DropDownNext>
      </div>
    </div>
    <div class="main-content">
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import DropDownNext from '../../../components/DropDownNext.vue'
import click from '../../../tools/click'
import DropDown from '../../../components/DropDownSingle.vue'
export default {
  name: 'TimeMonitoring',
  components: { DropDownNext, DropDown },
  data () {
    return {
      resultData: this.$store.getters.resultData,
      transitionName: 'slide-fade',
      title: '实时监控',
      sortList: [
        {name: '以楼号排序', value: 0},
        {name: '以预警排序', value: 1}
      ],
      sort: '以楼号排序',
      itemList: [
        {title: '全部', sign: 1, path: '/warehouse'},
        {title: '传感器配置', sign: 0, path: '/warehouse/timeMonitoring/timeSensor'}
      ],
      selectList: [
        {title: '单个传感器曲线', id: 0},
        {title: '历史曲线', id: 1}
      ],
      value: '0'
    }
  },
  created () {
    let value = parseInt(this.$route.query.value)
    if (isNaN(value)) {
      value = 0
    }
    this.itemList.map((data, ind) => {
      if (value === ind) {
        data.sign = 1
      } else {
        data.sign = 0
      }
    })
    this.value = value
  },
  watch: {
    '$route' () {
      let value = parseInt(this.$route.query.value)
      if (isNaN(value)) {
        value = 0
      }
      this.itemList.map((data, ind) => {
        if (value === ind) {
          data.sign = 1
        } else {
          data.sign = 0
        }
      })
    }
  },
  methods: {
    showInfo: function (data) {
      let _this = this
      setTimeout(function () {
        console.log(data.id)
        if (data.id === 0) {
          _this.$router.push({
            path: '/warehouse/singleCurve',
            query: {
              index: '3'
            }
          })
        } else if (data.id === 1) {
          _this.$router.push({
            path: '/warehouse/historyCurve',
            query: {
              index: '3'
            }
          })
        }
      }, 0)
    },
    changeBg: function (index) {
      this.sort = '以楼号排序'
      this.value = index
      this.itemList.map((data, ind) => {
        if (index === ind) {
          data.sign = 1
          this.$router.push({
            path: data.path,
            query: {
              index: '3',
              value: index
            }
          })
        } else {
          data.sign = 0
        }
      })
    },
    showInfoA: function (data) {
      console.log(data)
      click.$emit('click_sort', data.value)
      this.sort = data.name
    }
  }
}
</script>

<style scoped>
@import "Warehouse.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warehouse/WareTimeMonitoring.vue